import {
    Directive,
    ElementRef,
    HostListener
} from '@angular/core';

@Directive({
  standalone: false,
    selector: '[appRemoveFocus]'
})
export class RemoveFocusDirective {

    constructor(private el: ElementRef) {}

    @HostListener('click') 
    onClick() {
       this.el.nativeElement.blur();
    }
}
